export function NotFoundMsg() {
  return (
    <div>Forbidden! Your IP is not allowed to do that!</div>
  );
}
